import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "orderForm",
  action: "/cart",
  method: "POST"
}
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "mb-4 align-items-center" }
const _hoisted_5 = { class: "card col-xl-12 mt-1" }
const _hoisted_6 = { class: "table align-items-center mb-0" }
const _hoisted_7 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_8 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_9 = { class: "text-uppercase text-center text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }
const _hoisted_10 = { class: "text-center text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 d-none d-md-table-cell" }
const _hoisted_11 = { class: "text-center text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 d-none d-md-table-cell" }
const _hoisted_12 = { class: "text-center text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_13 = { class: "text-center text-end text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_14 = {
  key: 0,
  colspan: "7"
}
const _hoisted_15 = {
  key: 0,
  id: "pos-section"
}
const _hoisted_16 = { colspan: "7" }
const _hoisted_17 = {
  class: "alert alert-success text-white text-wrap text-break w-75",
  role: "alert"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  colspan: "7",
  class: "text-wrap text-break"
}
const _hoisted_22 = { class: "text-wrap" }
const _hoisted_23 = { class: "td-image d-flex justify-content-center align-items-center" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { class: "text-wrap text-break" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "mb-0" }
const _hoisted_28 = { class: "tiny" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 0,
  class: "delivery-available"
}
const _hoisted_32 = {
  key: 1,
  class: "delivery-indelivery"
}
const _hoisted_33 = {
  key: 2,
  class: "delivery-backordered"
}
const _hoisted_34 = {
  key: 3,
  class: "delivery-backordered"
}
const _hoisted_35 = ["onUpdate:modelValue", "name"]
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "text-center d-none d-md-table-cell" }
const _hoisted_38 = { class: "text-center d-none d-md-table-cell" }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "text-end" }
const _hoisted_41 = { class: "card mt-1" }
const _hoisted_42 = { class: "card-body p-2" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-5" }
const _hoisted_45 = { class: "col-md-4 col-8 text-end" }
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-md-9 col-8 text-end" }
const _hoisted_49 = { class: "col-md-3 col-4 text-end" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-9 col-8 text-end" }
const _hoisted_52 = { class: "col-md-3 col-4 text-end" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-9 col-8 text-end" }
const _hoisted_55 = { class: "col-md-3 col-4 text-end" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-md-9 col-8 text-end" }
const _hoisted_58 = { class: "col-md-3 col-4 text-end" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-md-9 col-8 text-end" }
const _hoisted_61 = { class: "col-md-3 col-4 text-end" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-9 col-8 text-end" }
const _hoisted_64 = {
  class: "badge badge-pill badge-lg bg-gradient-success pricing-tier",
  "data-bs-toggle": "modal",
  "data-bs-target": "#pricingTiersModal",
  href: "#"
}
const _hoisted_65 = { class: "col-md-3 col-4 text-end" }
const _hoisted_66 = { class: "text-success" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-md-9 col-8 text-end" }
const _hoisted_69 = { class: "col-md-3 col-4 text-end" }
const _hoisted_70 = { class: "row mt-1" }
const _hoisted_71 = { class: "col-md-9 col-8 text-end" }
const _hoisted_72 = { class: "col-md-3 col-4 text-end" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = {
  key: 0,
  class: "row"
}
const _hoisted_76 = { class: "col-md-9 col-8 text-end" }
const _hoisted_77 = { class: "col-md-3 col-4 text-end green" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-md-9 col-8 text-end" }
const _hoisted_80 = { class: "col-md-3 col-4 text-end" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-md-9 col-8 text-end" }
const _hoisted_83 = { class: "col-md-3 col-4 text-end" }
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-md-9 col-8 text-end" }
const _hoisted_86 = { class: "col-md-3 col-4 text-end" }
const _hoisted_87 = { class: "text-decoration-underline" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { class: "card mt-1" }
const _hoisted_90 = { class: "card-body p-2" }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-lg-12" }
const _hoisted_93 = { class: "card mt-1" }
const _hoisted_94 = { class: "card-body p-2" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "col-lg-6" }
const _hoisted_98 = {
  class: "form-control",
  name: "shipping_address_id",
  required: ""
}
const _hoisted_99 = ["value"]
const _hoisted_100 = {
  href: "/partner-account",
  class: "tiny mt-1"
}
const _hoisted_101 = { class: "col-lg-6" }
const _hoisted_102 = {
  class: "form-control address",
  name: "billing_address_id",
  required: ""
}
const _hoisted_103 = ["value"]
const _hoisted_104 = {
  href: "/partner-account",
  class: "tiny mt-1"
}
const _hoisted_105 = { class: "col-lg-6 mt-3" }
const _hoisted_106 = {
  href: "/invoice-email",
  class: "tiny mt-1"
}
const _hoisted_107 = { class: "card mt-1" }
const _hoisted_108 = { class: "card-body p-2" }
const _hoisted_109 = { class: "row" }
const _hoisted_110 = { class: "row" }
const _hoisted_111 = { class: "col-lg-5" }
const _hoisted_112 = { class: "form-check" }
const _hoisted_113 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_114 = { class: "col-lg-5 offset-lg-2" }
const _hoisted_115 = { class: "row" }
const _hoisted_116 = { class: "col-lg-6" }
const _hoisted_117 = { class: "col-lg-6" }
const _hoisted_118 = { class: "form-check mt-1" }
const _hoisted_119 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_120 = {
  key: 0,
  class: "col-lg-5"
}
const _hoisted_121 = { class: "form-check" }
const _hoisted_122 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_123 = { class: "mt-1 text-end" }
const _hoisted_124 = {
  key: 0,
  class: "tiny fw-bold"
}
const _hoisted_125 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_126 = { class: "modal-content" }
const _hoisted_127 = { class: "modal-header" }
const _hoisted_128 = {
  id: "palletModalLabel",
  class: "modal-title"
}
const _hoisted_129 = { class: "modal-body" }
const _hoisted_130 = { class: "modal-footer" }
const _hoisted_131 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_132 = { class: "modal-content" }
const _hoisted_133 = { class: "modal-header" }
const _hoisted_134 = {
  id: "confirmModalLabel",
  class: "modal-title"
}
const _hoisted_135 = { class: "modal-body" }
const _hoisted_136 = {
  href: "https://sonnenglas.net/tos",
  target: "_blank"
}
const _hoisted_137 = { class: "modal-footer" }
const _hoisted_138 = {
  type: "button",
  class: "btn bg-gradient-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_139 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_140 = { class: "modal-content" }
const _hoisted_141 = { class: "modal-header" }
const _hoisted_142 = { class: "modal-title" }
const _hoisted_143 = { class: "modal-body" }
const _hoisted_144 = { class: "modal-footer" }
const _hoisted_145 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_146 = { class: "modal-content" }
const _hoisted_147 = { class: "modal-header" }
const _hoisted_148 = { class: "modal-title" }
const _hoisted_149 = { class: "modal-body" }
const _hoisted_150 = { class: "modal-footer" }
const _hoisted_151 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_152 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_153 = { class: "modal-content" }
const _hoisted_154 = { class: "modal-header" }
const _hoisted_155 = { class: "modal-title" }
const _hoisted_156 = { class: "modal-body" }
const _hoisted_157 = { class: "modal-footer" }
const _hoisted_158 = {
  type: "button",
  class: "btn bg-gradient-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_159 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_160 = { class: "modal-content" }
const _hoisted_161 = { class: "modal-header" }
const _hoisted_162 = { class: "modal-title" }
const _hoisted_163 = { class: "modal-body" }
const _hoisted_164 = { key: 0 }
const _hoisted_165 = { key: 1 }
const _hoisted_166 = { key: 2 }
const _hoisted_167 = { class: "modal-footer" }
const _hoisted_168 = {
  type: "button",
  class: "btn bg-gradient-primary",
  "data-bs-dismiss": "modal"
}

import _ from "lodash";
import { ref, computed, watch, onMounted, nextTick } from "vue";
import { Modal } from "bootstrap";
import { Product, ProductGroup } from "@/types/product";
import { PricingTier } from "@/types/pricingTier";
import { Quantities } from "@/types/quantities";
import { getShippingData, getCartDeliveryPeriod } from "../libs/api";

import {
  toCurrency as toCurrencyFunc,
  toNumber,
  getTotalWeight,
  getTotalQuantity,
  getTotalGroupQuantity,
  getDeliveryTime,
  checkAllowedPalletShipping,
  didMetMinimumForProductGroup,
} from "../libs/utils";

import {
  getDefaultPricingTier,
  getPricingTier,
  getPriceBeforeDiscount,
  getNetPriceAfterDiscount,
  getDiscountForFixedNetPrice,
} from "../libs/discounts";

import { CartItem } from "@/types/cart";
import { ReplacementsInterface } from "@/types/replacements";
import DatePickerComponent from "./DatePickerComponent.vue";
import { ShortAddress } from "@/types/addresses";
import { trans } from "laravel-vue-i18n";

const PLACEHOLDER_IMAGE = "/images/placeholder.svg";

// Missing product photo: show the placeholder instead of a broken image
interface Props {
  products: Product[];
  productGroups: ProductGroup[];
  pricingTiers: PricingTier[];
  cart: CartItem[];
  currency: string;
  invoiceEmail: string;
  country: string;
  paymentMethod: string;
  csrfToken: string;
  taxRate: number;
  shippingAddresses: ShortAddress[];
  billingAddresses: ShortAddress[];
}

const MINIMUM_ORDER_QUANTITY = 8;



export default /*@__PURE__*/_defineComponent({
  __name: 'CartComponent',
  props: {
    products: {},
    productGroups: {},
    pricingTiers: {},
    cart: {},
    currency: {},
    invoiceEmail: {},
    country: {},
    paymentMethod: {},
    csrfToken: {},
    taxRate: {},
    shippingAddresses: {},
    billingAddresses: {}
  },
  setup(__props: any) {

function onImageError(event: Event) {
  const img = event.target as HTMLImageElement;
  if (!img.src.endsWith(PLACEHOLDER_IMAGE)) {
    img.src = PLACEHOLDER_IMAGE;
  }
}

const props = __props;

const quantities = ref<Quantities>({});

const asap = ref(true);

const miscDiscount = ref(0);

const partialDelivery = ref(true);

const palletShipping = ref(false);

const shippingCosts = ref(0);

const boxQuantity = ref(0);

const shippingVolume = ref(0);

const alreadyShowedPalletShippingModal = ref(false);

const palletModalRef = ref<HTMLElement | null>(null);

const confirmModalRef = ref<HTMLElement | null>(null);

const posModalRef = ref<HTMLElement | null>(null);

const posOnlyModalRef = ref<HTMLElement | null>(null);

const preOrderModalRef = ref<HTMLElement | null>(null);

const cannotOrderModalRef = ref<HTMLElement | null>(null);

const earliestShippingDate = ref<string | null>(null);

const hasPreOrderProducts = ref(false);

const hasShownPreOrderModal = ref(false);

const cartDeliveryPeriod = ref<string | null>(null);

const isLoadingDelivery = ref(false);

props.products.forEach((product) => {
  quantities.value[product.sku] = 0;
});

const toCurrency = (price: number): string =>
  toCurrencyFunc(price, props.currency);

const showPaymentMethod = computed(() => {
  if (props.paymentMethod === "invoice") {
    return "auf Rechnung";
  } else {
    return "Vorkasse";
  }
});


const getTax = (price: number): number => {
  return (price * props.taxRate) / 100;
};

const getGroupProducts = (id: number): Product[] => {
  return props.products.filter((product) => product.group === id);
};

const getTotalNetWithoutShipping = computed((): number => {
  return props.products.reduce((total, product) => {
    return total + getNetDiscountedUnitPrice(product) * quantities.value[product.sku];
  }, 0);
});

const totalNetPrice = computed((): number => {
  return getTotalNetWithoutShipping.value + shippingCosts.value - miscDiscount.value;
});

const getTotalMSRP = computed((): number => {
  return props.products.reduce((total, product) => {
    return (
      total + getUnitPrice(product, false) * quantities.value[product.sku]
    );
  }, 0);
});

const totalGrossPrice = computed(() => {
  return totalNetPrice.value + getTax(totalNetPrice.value);
});

const allowedPalletShipping = computed(() => {
  if (checkAllowedPalletShipping(quantities.value)) {
    if (!alreadyShowedPalletShippingModal.value) {
      if (palletModalRef.value) {
        Modal.getOrCreateInstance(palletModalRef.value).show();
        alreadyShowedPalletShippingModal.value = true;
      }
    }
    return true;
  } else {
    palletShipping.value = false;
    alreadyShowedPalletShippingModal.value = false;
    return false;
  }
});

const totalQuantity = computed(() => {
  return getTotalQuantity(quantities.value);
});

const totalWeight = computed(() => {
  return getTotalWeight(props.products, quantities.value);
});

const currentPricingTier = computed(() => {
  return getDefaultPricingTier(props.pricingTiers, quantities.value, props.products);
});

const getProductPricingTier = (product: Product): PricingTier => {
  if (product.forcedPricingTier && product.forcedPricingTier.length) {
    return getPricingTier(props.pricingTiers, product.forcedPricingTier);
  }

  return currentPricingTier.value;
};

const reachedMinimumForProductGroup = computed((): boolean => {
  return didMetMinimumForProductGroup(quantities.value, props.productGroups, props.products);
});

const getNetDiscountedUnitPrice = (product: Product): number => {
  if (!product.price) {
    throw new Error("Product has no price:" + product.sku);
  }

  if (product.excludedFromDiscounts) {
    if (product.fixedNetPrice !== null) {
      return product.fixedNetPrice.value;
    }
    return product.price.value;
  }


  if (!product.price) {
    throw new Error("Product has no price:" + product.sku);
  }


  if (product.fixedNetPrice !== null) {
    return product.fixedNetPrice.value;
  }

  const productPricingTier = getProductPricingTier(product);

  return getNetPriceAfterDiscount(
    product.price,
    productPricingTier.discount,
    props.taxRate
  );
};

const getUnitPrice = (product: Product, netPricing: boolean): number => {
  return getPriceBeforeDiscount(product.price, props.taxRate, netPricing);
};

const currentRealDiscount = computed(() => {
  if (getTotalMSRP.value === 0) {
    return 0;
  }


  const discount = Math.round(100 * (getTotalMSRP.value - getTotalNetWithoutShipping.value) / getTotalMSRP.value);
  return discount;
});



const noAddressModal = new Modal("#noAddressModal");
if (props.shippingAddresses.length <= 0 && props.billingAddresses.length <= 0) {
  noAddressModal.show();
}

const transReplacements = (obj: {
  [key: string]: number | string;
}): ReplacementsInterface => {
  const result: ReplacementsInterface = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = String(obj[key]);
    }
  }
  return result;
};


const orderDeliveryTime = computed(() => {
  if (isLoadingDelivery.value) {
    return '<span class="delivery-loading">' + trans("Loading...") + '</span>';
  }

  if (!cartDeliveryPeriod.value) {
    return '';
  }

  return cartDeliveryPeriod.value;
});



const calculateMiscDiscount = (): void => {
  console.log("Calculating misc discount");

  miscDiscount.value = 0;

  const freePosQuantity = currentPricingTier.value.name === "01" ? 1 : 3;

  let remainingFreePosQuantity = freePosQuantity;

  props.products.forEach((product) => {
    if (!product.isPos || !quantities.value[product.sku]) return;

    const quantity = quantities.value[product.sku];

    const freeForThisItem = Math.min(quantity, remainingFreePosQuantity);

    miscDiscount.value += getNetDiscountedUnitPrice(product) * freeForThisItem;

    remainingFreePosQuantity -= freeForThisItem;

    if (remainingFreePosQuantity <= 0) {
      return;
    }
  });

  // Ensure the discount value is rounded to 2 decimal places
  miscDiscount.value = parseFloat(miscDiscount.value.toFixed(2));
};

const updateShippingCosts = () => {
  getShippingData(quantities.value, props.country).then((res) => {
    shippingCosts.value = res.shippingCosts;
    boxQuantity.value = res.boxQuantity;
    shippingVolume.value = res.volume / 1000000000;
  });
};

const updateCartDeliveryPeriod = async () => {
  const hasItems = Object.values(quantities.value).some(quantity => quantity > 0);
  
  if (!hasItems) {
    cartDeliveryPeriod.value = null;
    return;
  }

  isLoadingDelivery.value = true;

  try {
    const response = await getCartDeliveryPeriod(quantities.value, props.country);
    
    if (response.delivery_period) {
      const start = new Date(response.delivery_period.start);
      const end = new Date(response.delivery_period.end);
      const now = new Date();
      
      // Calculate weeks from now
      const startWeeks = Math.max(0, Math.ceil((start.getTime() - now.getTime()) / (1000 * 60 * 60 * 24 * 7)));
      const endWeeks = Math.max(0, Math.ceil((end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24 * 7)));
      
      if (startWeeks === 0 && endWeeks === 0) {
        cartDeliveryPeriod.value = '<span class="delivery-available">' + trans("immediately available") + '</span>';
      } else if (startWeeks < 4 && endWeeks < 4) {
        cartDeliveryPeriod.value = '<span class="delivery-indelivery">' + startWeeks + ' - ' + endWeeks + ' ' + trans("weeks") + '</span>';
      } else {
        cartDeliveryPeriod.value = '<span class="delivery-backordered">' + startWeeks + ' - ' + endWeeks + ' ' + trans("weeks") + '</span>';
      }
    }
  } catch (error) {
    console.error('Failed to fetch delivery period:', error);
    cartDeliveryPeriod.value = null;
  } finally {
    isLoadingDelivery.value = false;
  }
};

const updateFormCart = () => {
  props.cart.forEach((item) => {
    quantities.value[item.productSku] = item.quantity;
  });
};

const applyLaunchPromotion = () => {
  props.products.forEach((product) => {
    if ((product.group === 2 || product.group === 3) && quantities.value[product.sku] < 2) {
      quantities.value[product.sku] = 2;
    }
  });
};

const isPosOnlyOrder = computed(() => {
  return props.products.every(product =>
    quantities.value[product.sku] == 0 || product.isPos
  );
});

const isExemptFromMinimumOrder = computed(() => {
  return props.products.every(product =>
    quantities.value[product.sku] == 0 || product.isPos || product.group === 6
  );
});

const remainingFreePOSMaterials = computed(() => {
  if (isPosOnlyOrder.value) {
    return 0;
  }

  const freeItemsAllowed = currentPricingTier.value.name === "01" ? 1 : 3;
  const freeItemsSelected = props.products.reduce((count, product) => {
    if (product.isPos) {
      count += quantities.value[product.sku] || 0;
    }
    return count;
  }, 0);

  return Math.max(0, freeItemsAllowed - freeItemsSelected);
});

const confirmPosOnlyOrder = () => {
  const form = document.getElementById("orderForm") as HTMLFormElement;
  if (form) {
    form.submit();
  } else {
    console.error("Form not found");
  }
};

const submitForm = (forceSubmit: boolean = false) => {
  // Check if order cannot be placed
  const cannotOrder = totalQuantity.value === 0 || (!isExemptFromMinimumOrder.value && (totalQuantity.value < MINIMUM_ORDER_QUANTITY || !reachedMinimumForProductGroup.value));

  if (cannotOrder) {
    if (cannotOrderModalRef.value) {
      const cannotOrderModal = Modal.getOrCreateInstance(cannotOrderModalRef.value);
      cannotOrderModal.show();
    } else {
      console.error('Cannot order modal ref is not defined');
    }
    return;
  }

  if (isPosOnlyOrder.value) {
    console.log("POS-only order detected");

    if (posOnlyModalRef.value) {
      const posOnlyModal = Modal.getOrCreateInstance(posOnlyModalRef.value);
      posOnlyModal.show();
      return;
    } else {
      console.error("POS-only modal ref is not defined");
    }
  }

  // Check for free POS materials logic
  if (!forceSubmit && remainingFreePOSMaterials.value > 0) {

    if (posModalRef.value) {
      const posModal = Modal.getOrCreateInstance(posModalRef.value);
      posModal.show();
    } else {
      console.error('POS modal ref is not defined');
    }
    return;
  }

  // Show the confirm modal
  if (confirmModalRef.value) {
    const confirmModal = Modal.getOrCreateInstance(confirmModalRef.value);
    confirmModal.show();
  } else {
    console.error('Confirm modal ref is not defined');
  }
};

const showPreOrderModalIfNeeded = () => {
  // Pre-order functionality disabled as current API doesn't provide pre-order status
  const isNowPreOrder = false;

  // Show modal only when transitioning from 0 pre-order products → at least 1 pre-order product
  if (isNowPreOrder && !hasPreOrderProducts.value && !hasShownPreOrderModal.value) {
    hasPreOrderProducts.value = true;
    hasShownPreOrderModal.value = true; // Prevent re-showing

    if (preOrderModalRef.value) {
      const preOrderModal = Modal.getOrCreateInstance(preOrderModalRef.value);
      preOrderModal.show();
    }
  }
};


const confirmAndSubmitForm = () => {
  const form = document.getElementById("orderForm") as HTMLFormElement;
  if (form) {
    form.submit();
  } else {
    console.error('Form not found');
  }
};

const scrollToPosMaterials = async () => {
  const posModal = Modal.getInstance(posModalRef.value);
  if (posModal) {
    posModal.hide();
  }

  await nextTick();

  const posSection = document.querySelector("#pos-section");
  if (posSection) {
    posSection.scrollIntoView({ behavior: "smooth", block: "center" });
  } else {
    console.error("POS section not found");
  }

};

watch(
  () => _.cloneDeep(quantities.value),
  (currVal, prevVal) => {
    updateShippingCosts();
    calculateMiscDiscount();
    updateCartDeliveryPeriod();
    showPreOrderModalIfNeeded();
  },
  { deep: true }
);

watch(palletShipping, (currVal, prevVal) => {
  if (palletShipping.value) {
    shippingCosts.value = 0;
  } else {
    updateShippingCosts();
  }
});

onMounted(() => {
  updateFormCart();
  updateShippingCosts();
  updateCartDeliveryPeriod();

  if (palletModalRef.value) {
    Modal.getOrCreateInstance(palletModalRef.value);
  }

  if (posModalRef.value) {
    Modal.getOrCreateInstance(posModalRef.value);
  } else {
    console.error('posModalRef is not defined');
  }

  if (confirmModalRef.value) {
    Modal.getOrCreateInstance(confirmModalRef.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("input", {
      type: "hidden",
      name: "_token",
      value: _ctx.csrfToken
    }, null, 8, _hoisted_2),
    _cache[21] || (_cache[21] = _createElementVNode("input", {
      type: "hidden",
      name: "purchase",
      value: "yes"
    }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("Product")), 1),
                _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("Product")), 1),
                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("Quantity")), 1),
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("RRP")) + " (" + _toDisplayString(_ctx.$t("gross")) + ") ", 1),
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("Discount Tier")), 1),
                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("PO price")) + " (" + _toDisplayString(_ctx.$t("net")) + ") ", 1),
                _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("Subtotal")), 1)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productGroups, (productGroup) => {
              return (_openBlock(), _createElementBlock("tbody", null, [
                _createElementVNode("tr", null, [
                  (getGroupProducts(productGroup.id).length > 0)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.$t(productGroup.name)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (productGroup.id == 5)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                      _createElementVNode("td", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _cache[10] || (_cache[10] = _createElementVNode("p", null, " Entdeckt unsere POS Materialien! Ergänzt eure Bestellungen mit Zusatz- und Informationsmaterialien für eure Verkaufsflächen. ", -1)),
                          _createElementVNode("p", null, [
                            _cache[8] || (_cache[8] = _createTextVNode(" Ihr könnt pro Bestellung ")),
                            (currentPricingTier.value.name == '01')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "ein kostenfreies POS Produkt"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_19, "bis zu drei kostenfreie POS Produkte")),
                            _cache[9] || (_cache[9] = _createTextVNode(" hinzufügen. Natürlich könnt ihr auch gern mehr POS Materialien darüber hinaus bestellen – dafür erheben wir eine Schutzgebühr von 1 € pro Artikel sowie eine Versandkostenpauschale. "))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (productGroup.minQuantity > 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("The minimum order quantity for the light carafes and adventure mounts is :quantity pieces in"
                        + " total (not per unit). You can freely choose the SKUs within the group.",
                        transReplacements({
                          quantity:
                            productGroup.minQuantity,
                        })
                      )), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupProducts(productGroup.id), (product) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", _hoisted_23, [
                      (product.image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "img-fluid w-30",
                            src: product.image + '_thumb.' + product.imageExt,
                            alt: product.name,
                            onError: onImageError
                          }, null, 40, _hoisted_24))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("a", {
                        href: '/products/' + product.sku,
                        class: "productName",
                        target: "_blank"
                      }, [
                        _createElementVNode("h6", _hoisted_27, _toDisplayString(product.name), 1)
                      ], 8, _hoisted_26),
                      _createElementVNode("span", _hoisted_28, [
                        (product.description.length < 100)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              innerHTML: product.description
                            }, null, 8, _hoisted_29))
                          : _createCommentVNode("", true),
                        _createTextVNode(" · SKU: " + _toDisplayString(product.sku.replace("-de", "")), 1),
                        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                        (product.deliveryInWeeksFrom !== undefined && product.deliveryInWeeksTo !== undefined)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                              _createTextVNode(_toDisplayString(_ctx.$t("Estimated delivery time")) + ": ", 1),
                              (product.deliveryInWeeksFrom === 0 && product.deliveryInWeeksTo === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t("immediately available")), 1))
                                : (product.deliveryInWeeksFrom < 4 && product.deliveryInWeeksTo < 4)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t("in delivery")) + " (" + _toDisplayString(product.deliveryInWeeksFrom) + " - " + _toDisplayString(product.deliveryInWeeksTo) + " " + _toDisplayString(_ctx.$t("weeks")) + ")", 1))
                                  : (product.deliveryInWeeksFrom == product.deliveryInWeeksTo)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t("backordered")) + " (" + _toDisplayString(product.deliveryInWeeksFrom) + " " + _toDisplayString(_ctx.$t("weeks")) + ") ", 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t("backordered")) + " (" + _toDisplayString(product.deliveryInWeeksFrom) + " - " + _toDisplayString(product.deliveryInWeeksTo) + " " + _toDisplayString(_ctx.$t("weeks")) + ") ", 1))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((quantities.value[product.sku]) = $event),
                        name: 'quantities[' + product.sku + ']',
                        class: "form-select text-center"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.availableQuantities, (i) => {
                          return (_openBlock(), _createElementBlock("option", { value: i }, _toDisplayString(i), 9, _hoisted_36))
                        }), 256))
                      ], 8, _hoisted_35), [
                        [_vModelSelect, quantities.value[product.sku]]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_37, _toDisplayString(toCurrency(getUnitPrice(product, false))), 1),
                    _createElementVNode("td", _hoisted_38, [
                      (product.fixedNetPrice === null && product.excludedFromDiscounts === false)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: _normalizeClass(["badge badge-pill pricing-tier", quantities.value[product.sku] > 0 ? 'bg-gradient-success' : 'bg-gradient-secondary']),
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#pricingTiersModal",
                            href: "#"
                          }, _toDisplayString(getProductPricingTier(product).name) + " (" + _toDisplayString(getProductPricingTier(product).discount) + "%)", 3))
                        : (product.excludedFromDiscounts === false)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: _normalizeClass(["badge badge-pill pricing-tier", quantities.value[product.sku] > 0 ? 'bg-gradient-success' : 'bg-gradient-secondary']),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#pricingTiersNewProductsModal",
                              href: "#"
                            }, _toDisplayString(_unref(getDiscountForFixedNetPrice)(
                        product.price,
                        product.fixedNetPrice
                      )) + "%", 3))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_39, _toDisplayString(toCurrency(getNetDiscountedUnitPrice(product))), 1),
                    _createElementVNode("td", _hoisted_40, _toDisplayString(toCurrency(getNetDiscountedUnitPrice(product) * quantities.value[product.sku])), 1)
                  ]))
                }), 256))
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createTextVNode(_toDisplayString(_ctx.$t("Payment method")) + ": ", 1),
                _createElementVNode("b", null, _toDisplayString(showPaymentMethod.value), 1)
              ]),
              _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t("Estimated delivery time")), 1),
              (totalQuantity.value > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "col-md-3 col-4 text-end",
                    innerHTML: orderDeliveryTime.value
                  }, null, 8, _hoisted_46))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("Total quantity")), 1),
              _createElementVNode("div", _hoisted_49, _toDisplayString(totalQuantity.value), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t("Number of shipping boxes")), 1),
              _createElementVNode("div", _hoisted_52, _toDisplayString(boxQuantity.value), 1)
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t("Volume")), 1),
              _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(toNumber)(shippingVolume.value)) + " cbm ", 1)
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t("Gross weight")), 1),
              _createElementVNode("div", _hoisted_58, _toDisplayString(totalWeight.value) + " kg ", 1)
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "col" }, [
                _createElementVNode("hr", { class: "horizontal dark mt-lg-2" })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t("Total")) + " " + _toDisplayString(_ctx.$t("RRP")) + " (" + _toDisplayString(_ctx.$t("gross")) + ") ", 1),
              _createElementVNode("div", _hoisted_61, _toDisplayString(toCurrency(getTotalMSRP.value)), 1)
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("a", _hoisted_64, _toDisplayString(_ctx.$t("Pricing Tier")), 1)
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("span", _hoisted_66, _toDisplayString(currentRealDiscount.value) + "%", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t("Total")) + " " + _toDisplayString(_ctx.$t("PO price")) + " (" + _toDisplayString(_ctx.$t("net")) + ") ", 1),
              _createElementVNode("div", _hoisted_69, _toDisplayString(toCurrency(getTotalNetWithoutShipping.value)), 1)
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.$t("Shipping costs")) + " (" + _toDisplayString(_ctx.$t("net")) + ") ", 1),
              _createElementVNode("div", _hoisted_72, [
                (palletShipping.value || shippingCosts.value === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(_ctx.$t("On Request")), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(toCurrency(shippingCosts.value)), 1))
              ])
            ]),
            (miscDiscount.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$t("Discount")), 1),
                  _createElementVNode("div", _hoisted_77, " -" + _toDisplayString(toCurrency(miscDiscount.value)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.$t("Total")) + " (" + _toDisplayString(_ctx.$t("net")) + ") ", 1),
              _createElementVNode("div", _hoisted_80, _toDisplayString(toCurrency(totalNetPrice.value)), 1)
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.$t("plus VAT")) + " (" + _toDisplayString(_unref(toNumber)(_ctx.taxRate)) + "%) ", 1),
              _createElementVNode("div", _hoisted_83, _toDisplayString(toCurrency(getTax(totalNetPrice.value))), 1)
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("h6", null, _toDisplayString(_ctx.$t("Total")) + " (" + _toDisplayString(_ctx.$t("gross")) + ")", 1)
              ]),
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("h6", _hoisted_87, [
                  _createTextVNode(_toDisplayString(toCurrency(totalGrossPrice.value)) + " ", 1),
                  (palletShipping.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_88, "+ " + _toDisplayString(_ctx.$t("Shipping costs")), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t(
                      "Kindly provide necessary invoice notes, such as your company-internal order number, in this space."
                    )), 1),
                _cache[13] || (_cache[13] = _createElementVNode("textarea", {
                  class: "form-control",
                  name: "invoice_text"
                }, null, -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Delivery and billing address")), 1)
            ]),
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Delivery address")), 1),
                _createElementVNode("select", _hoisted_98, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shippingAddresses, (address) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: address.id
                    }, _toDisplayString(address.address), 9, _hoisted_99))
                  }), 256))
                ]),
                _createElementVNode("a", _hoisted_100, _toDisplayString(_ctx.$t("Edit or create a new address")), 1)
              ]),
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Invoice address")), 1),
                _createElementVNode("select", _hoisted_102, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billingAddresses, (address) => {
                    return (_openBlock(), _createElementBlock("option", {
                      "data-content": "ttt",
                      value: address.id
                    }, _toDisplayString(address.address), 9, _hoisted_103))
                  }), 256))
                ]),
                _createElementVNode("a", _hoisted_104, _toDisplayString(_ctx.$t("Edit or create a new address")), 1)
              ]),
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Invoice email")), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.invoiceEmail) + " ", 1),
                _createElementVNode("a", _hoisted_106, _toDisplayString(_ctx.$t("Edit or create a new address")), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Delivery settings & scheduling")), 1)
            ]),
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Partial delivery")), 1),
                _createElementVNode("div", _hoisted_112, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((partialDelivery).value = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    name: "partial_shipping_allowed",
                    value: "1"
                  }, null, 512), [
                    [_vModelCheckbox, partialDelivery.value]
                  ]),
                  _createElementVNode("label", _hoisted_113, _toDisplayString(_ctx.$t(
                        "I agree to partial deliveries and may receive available goods more quickly."
                      )), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Scheduling")), 1),
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.$t("Target delivery date")), 1),
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("div", _hoisted_118, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((asap).value = $event)),
                        class: "form-check-input",
                        type: "checkbox",
                        name: "asap",
                        value: "1"
                      }, null, 512), [
                        [_vModelCheckbox, asap.value]
                      ]),
                      _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t("as soon as possible")), 1)
                    ]),
                    _createVNode(DatePickerComponent, {
                      name: "earliest_shipping_date",
                      modelValue: earliestShippingDate.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((earliestShippingDate).value = $event)),
                      disabled: asap.value === true
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])
              ]),
              (allowedPalletShipping.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Pallet shipping")), 1),
                    _createElementVNode("div", _hoisted_121, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((palletShipping).value = $event)),
                        class: "form-check-input",
                        type: "checkbox",
                        name: "pallet_shipping",
                        value: "1"
                      }, null, 512), [
                        [_vModelCheckbox, palletShipping.value]
                      ]),
                      _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.$t("I prefer pallet shipping")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_123, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-lg bg-gradient-success",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm(false)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("Order now")), 1),
          _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
          (!isExemptFromMinimumOrder.value && totalQuantity.value < MINIMUM_ORDER_QUANTITY)
            ? (_openBlock(), _createElementBlock("span", _hoisted_124, _toDisplayString(_ctx.$t("Minimum order quantity")) + ": " + _toDisplayString(MINIMUM_ORDER_QUANTITY) + " " + _toDisplayString(_ctx.$t("Pcs.")), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", {
      id: "palletModal",
      ref_key: "palletModalRef",
      ref: palletModalRef,
      class: "modal fade",
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "palletModal",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_125, [
        _createElementVNode("div", _hoisted_126, [
          _createElementVNode("div", _hoisted_127, [
            _createElementVNode("h5", _hoisted_128, _toDisplayString(_ctx.$t("Pallet shipping")), 1),
            _cache[15] || (_cache[15] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, [
              _createElementVNode("span", { "aria-hidden": "true" }, "×")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_129, _toDisplayString(_ctx.$t("Due to the size of the order, would you like the package to be shipped on a"
                + " pallet? Information about shipping costs will be calculated later and sent"
                + " to you by e - mail"
              )), 1),
          _createElementVNode("div", _hoisted_130, [
            _createElementVNode("button", {
              type: "button",
              class: "btn bg-gradient-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (palletShipping.value = true))
            }, _toDisplayString(_ctx.$t("Yes")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn bg-gradient-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (palletShipping.value = false))
            }, _toDisplayString(_ctx.$t("No")), 1)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      id: "confirmModal",
      class: "modal fade",
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "confirmModal",
      "aria-hidden": "true",
      ref_key: "confirmModalRef",
      ref: confirmModalRef
    }, [
      _createElementVNode("div", _hoisted_131, [
        _createElementVNode("div", _hoisted_132, [
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("h5", _hoisted_134, _toDisplayString(_ctx.$t("Continue order process")), 1),
            _cache[16] || (_cache[16] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, [
              _createElementVNode("span", { "aria-hidden": "true" }, "×")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_135, [
            _createTextVNode(_toDisplayString(_ctx.$t("I accept the")) + " ", 1),
            _createElementVNode("a", _hoisted_136, _toDisplayString(_ctx.$t("ToS")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(
                "and would like to continue the ordering process"
              )), 1)
          ]),
          _createElementVNode("div", _hoisted_137, [
            _createElementVNode("button", _hoisted_138, _toDisplayString(_ctx.$t("No")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn bg-gradient-primary",
              onClick: confirmAndSubmitForm
            }, _toDisplayString(_ctx.$t("Yes, order")), 1)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      id: "posModal",
      ref_key: "posModalRef",
      ref: posModalRef,
      class: "modal fade",
      tabindex: "-1",
      "aria-labelledby": "posModal",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_139, [
        _createElementVNode("div", _hoisted_140, [
          _createElementVNode("div", _hoisted_141, [
            _createElementVNode("h5", _hoisted_142, _toDisplayString(_ctx.$t("Kostenlose POS-Materialien verfügbar")), 1),
            _cache[17] || (_cache[17] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("Möchtet Ihr eurer Bestellung kostenfreies POS Material hinzufügen?")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("Anzahl der verbleibenden kostenlosen POS-Materialien:")) + " " + _toDisplayString(remainingFreePOSMaterials.value), 1)
          ]),
          _createElementVNode("div", _hoisted_144, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (submitForm(true)))
            }, _toDisplayString(_ctx.$t("No")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: scrollToPosMaterials
            }, _toDisplayString(_ctx.$t("Ja, POS Material hinzufügen")), 1)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      id: "posOnlyModal",
      ref_key: "posOnlyModalRef",
      ref: posOnlyModalRef,
      class: "modal fade",
      tabindex: "-1",
      "aria-labelledby": "posOnlyModal",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_145, [
        _createElementVNode("div", _hoisted_146, [
          _createElementVNode("div", _hoisted_147, [
            _createElementVNode("h5", _hoisted_148, _toDisplayString(_ctx.$t("POS Material")), 1),
            _cache[18] || (_cache[18] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_149, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("Seid Ihr sicher, dass Ihr nicht auch Sonnenglas® Produkte bestellen möchtet? POS "
                + "Materialien können entweder separat oder zur Ergänzung gewählt werden.")), 1)
          ]),
          _createElementVNode("div", _hoisted_150, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: confirmPosOnlyOrder
            }, _toDisplayString(_ctx.$t("Nur POS Materialien")), 1),
            _createElementVNode("button", _hoisted_151, _toDisplayString(_ctx.$t("Zurück zum Produktkatalog")), 1)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      id: "preOrderModal",
      ref_key: "preOrderModalRef",
      ref: preOrderModalRef,
      class: "modal fade",
      tabindex: "-1",
      "aria-labelledby": "preOrderModal",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_152, [
        _createElementVNode("div", _hoisted_153, [
          _createElementVNode("div", _hoisted_154, [
            _createElementVNode("h5", _hoisted_155, _toDisplayString(_ctx.$t("Pre-Order Notice")), 1),
            _cache[19] || (_cache[19] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_156, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("Your shopping cart contains products that are in pre-order status and will be delivered at "
                + "a later date. If your cart includes both available and pre-order items, two separate orders "
                + "will be created: one for available products and pre-order for pre-ordered items.")), 1)
          ]),
          _createElementVNode("div", _hoisted_157, [
            _createElementVNode("button", _hoisted_158, _toDisplayString(_ctx.$t("Agree")), 1)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      id: "cannotOrderModal",
      ref_key: "cannotOrderModalRef",
      ref: cannotOrderModalRef,
      class: "modal fade",
      tabindex: "-1",
      "aria-labelledby": "cannotOrderModal",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_159, [
        _createElementVNode("div", _hoisted_160, [
          _createElementVNode("div", _hoisted_161, [
            _createElementVNode("h5", _hoisted_162, _toDisplayString(_ctx.$t("Order Not Possible")), 1),
            _cache[20] || (_cache[20] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_163, [
            (totalQuantity.value === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_164, _toDisplayString(_ctx.$t("Your cart is empty. Please add at least one product to place an order.")), 1))
              : (totalQuantity.value < MINIMUM_ORDER_QUANTITY && !isExemptFromMinimumOrder.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_165, _toDisplayString(_ctx.$t("The minimum order quantity is :minimum pieces. You currently have :quantity items in your cart.",
                transReplacements({ minimum: MINIMUM_ORDER_QUANTITY, quantity: totalQuantity.value }))), 1))
                : (!reachedMinimumForProductGroup.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_166, _toDisplayString(_ctx.$t("You have not reached the minimum order quantity for certain product groups. Please check the requirements above.")), 1))
                  : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_167, [
            _createElementVNode("button", _hoisted_168, _toDisplayString(_ctx.$t("OK")), 1)
          ])
        ])
      ])
    ], 512)
  ]))
}
}

})